import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@mui/material";

const PwaPrompt = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    const hasPrompted = localStorage.getItem("pwaPrompt");

    if (!isStandalone && !hasPrompted) {
      setShowPopup(true);
    }

    // Listen for the 'beforeinstallprompt' event
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault(); // Prevent auto-showing the prompt
      setDeferredPrompt(e); // Save the event for later use
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstall = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt(); // Show the install prompt
  
      const choiceResult = await deferredPrompt.userChoice;
      if (choiceResult.outcome === "accepted") {
        console.log("User accepted the PWA install.");
      } else {
        console.log("User dismissed the PWA install.");
      }
  
      // Only reset if the user dismissed
      if (choiceResult.outcome === "dismissed") {
        setDeferredPrompt(null);
      }
    }
  
    setShowPopup(false);
    localStorage.setItem("pwaPrompt", "true"); // Prevent showing again
  };

  return (
    <Dialog open={showPopup} onClose={() => setShowPopup(false)}>
      <DialogTitle>Install PWA App</DialogTitle>
      <DialogContent>
        <p>
          You're browsing from a web browser. For a better experience, install this app to your
          device.
        </p>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleInstall} color="primary">
          Install
        </Button>
        <Button onClick={() => setShowPopup(false)} color="secondary">
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PwaPrompt;
